import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, SearchIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    name: 'News',
    path: '/'
  }, {
    name: 'Predictions',
    path: '/predictions'
  }, {
    name: 'Bounties',
    path: '/bounties'
  }];
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-149">
      <div className="container mx-auto px-4 lg:px-6" data-id="element-150">
        <div className="flex items-center justify-between h-16" data-id="element-151">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-152">
            <Link to="/" data-id="element-153">
              <h1 className="text-2xl font-bold tracking-tighter" data-id="element-154">PROTOCOL</h1>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:block" data-id="element-155">
            <ul className="flex space-x-8" data-id="element-156">
              {navItems.map(item => <li key={item.name} data-id="element-157">
                  <Link to={item.path} className="text-gray-900 hover:text-blue-600 font-bold" data-id="element-158">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </nav>
          {/* Search and Mobile Menu Buttons */}
          <div className="flex items-center space-x-4" data-id="element-159">
            <button className="text-gray-500 hover:text-gray-900" data-id="element-160">
              <SearchIcon className="h-5 w-5" data-id="element-161" />
            </button>
            <button className="md:hidden text-gray-500 hover:text-gray-900" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-162">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-163" /> : <MenuIcon className="h-6 w-6" data-id="element-164" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden" data-id="element-165">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200" data-id="element-166">
            {navItems.map(item => <Link key={item.name} to={item.path} className="block px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-167">
                {item.name}
              </Link>)}
          </div>
        </div>}
    </header>;
};